export default __webpack_public_path__ + "static/brain-d421598142b4853fa559ec724bef354b.png";